import { useEffect } from "react";
import { mix } from "@/color/oklch";
import { hexOf } from "@/model/resolve";
import { useEditor } from "@/store/editor";

const VARS = [
  "bg",
  "panel",
  "raised",
  "hover",
  "border",
  "fg",
  "muted",
  "faint",
  "accent",
  "accent-fg",
];

/** Dogfood mode: the app chrome uses the palette being edited. */
export function useDogfood(): void {
  const on = useEditor((s) => s.dogfood);
  const palette = useEditor((s) => s.draft.palette);
  const accent = useEditor((s) => hexOf(s.resolved, "ui.accent"));
  const variant = useEditor((s) => s.draft.variant);
  useEffect(() => {
    const root = document.documentElement.style;
    if (!on) {
      for (const v of VARS) root.removeProperty(`--chrome-${v}`);
      document.documentElement.style.colorScheme = "dark";
      return;
    }
    const p = palette;
    const values: Record<string, string> = {
      bg: p.bg0,
      panel: p.bg1,
      raised: p.bg2,
      hover: p.bg3,
      border: mix(p.bg2, p.bg4, 0.5),
      fg: p.fg1,
      muted: p.fg2,
      faint: p.fg3,
      accent,
      "accent-fg": p.bg1,
    };
    for (const [k, v] of Object.entries(values)) root.setProperty(`--chrome-${k}`, v);
    document.documentElement.style.colorScheme = variant;
  }, [on, palette, accent, variant]);
}
